site.sideContent = {
	init: function () {
		var $body = $('body');
		$body.append('<div id="sideContent" />');

		var $sideContent = $('#sideContent');
		$sideContent.append('<div class="wrapper" />');
		$('.wrapper', $sideContent)
			.on('click', function (e) {
				//e.stopPropagation();
			})
			.append('<button class="close" aria-label="Close" />')
			.append('<div class="content" />')
		;

		$('.close', $sideContent).on('click', function (e) {
			$body.removeClass('sideContent-open');
		});

		// Close side content on body click, outside side content area
		$body.click(function (e) {
			if ($(e.target).parents('#sideContent').length === 0 && $body.hasClass('sideContent-open')) {
				$body.removeClass('sideContent-open');
			}
		});

		// Close side content if escape key is pressed
		$(document).keyup(function (e) {
			if (e.keyCode === 27) {
				if ($body.hasClass('sideContent-open')) {
					$body.removeClass('sideContent-open');
				}
			}
		});

		$('a.sideContent, .sideContent > a').on('click', function (e) {
			var $this = $(this),
				directUrl = $this.data('direct')
			;
			if (directUrl) {
				e.preventDefault();

				$.ajax({
					type: 'GET',
					url: directUrl,
					dataType: 'html',
					success: function (data) {
						site.sideContent.appendData(data);
					}
				});
			}
			else {
				e.preventDefault();
				e.stopPropagation();

				site.sideContent.loadPageContent($(e.currentTarget).attr('href'));
			}
		});
	},

	appendData: function (data) {
		$('.content', $('#sideContent')).empty().append(data);
		$('body').addClass('sideContent-open');
	},

	lastPageUrl: '',
	loadPageContent: function (url) {
		if (site.sideContent.lastPageUrl !== url) {
			$.get(url, function (data) {
				var $r = $(data);
				var $data = $('#main > .row', $r).html();
				if($data) {
					site.sideContent.appendData($('#main > .row', $r).html());
				}
				else {
					site.sideContent.appendData($r);
				}
				site.sideContent.contentLoaded();
			});
			site.sideContent.lastPageUrl = url;
		}
		else {
			$('body').addClass('sideContent-open');
		}
	},

	contentLoaded: function () {
		$('form', '#sideContent').on('submit', function (e) {
			e.preventDefault();
			$.post($(this).attr('action'), $(this).serialize(), function (r) {
				var $data = $('#main > .row', r);
				site.sideContent.appendData($data.html());
				site.sideContent.contentLoaded();

				if (!$('form', $data).length) {
					site.sideContent.lastPageUrl = '';
				}
			});
		});
		site.labelFocus.init();
		if ($('.filter', '#sideContent').length > 0) {
			site.dataFilter.init('#sideContent .filter', '#sideContent .items')
		}
	}
};